import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'list': [],
  'lastId': null,
  'loading': false,
};

export const wtsAgendas = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_AGENDAS]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_AGENDAS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data || action.response || [],
    }),
    [ActionTypes.FETCHED_WTS_AGENDAS_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CREATING_WTS_AGENDA]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATED_WTS_AGENDA]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CREATED_WTS_AGENDA_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_WTS_AGENDA]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_WTS_AGENDA]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_WTS_AGENDA_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.DELETING_WTS_AGENDA]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETED_WTS_AGENDA]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.DELETED_WTS_AGENDA_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHING_WTS_AGENDA_LAST_ID]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_AGENDA_LAST_ID]: (state, action) => {
      const data = action.response && action.response.data ? action.response.data : action.response;
      return {
        ...state,
        'loading': false,
        'lastId': data,
      };
    },
    [ActionTypes.FETCHED_WTS_AGENDA_LAST_ID_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'lastId': null,
    }),
  })(state, action);
};
